import { useState } from 'react';
import { Button } from '@cof/omni-react';

export const CopyUrlButton = ({ message }: { message: string }) => {
  const [buttonText, setButtonText] = useState('Copy to Clipboard');

  const handleCopyClick = () => {
    navigator.clipboard.writeText(window.location.href);
    setButtonText('Copied');

    setTimeout(() => {
      setButtonText('Copy to Clipboard');
    }, 1000);
  };

  return (
    <div data-testid="CopyUrlButton">
      <div>
        <p data-testid="CopyUrlButton--Message">{message}</p>
        {window.location.href}
      </div>
      <Button
        data-testid="CopyUrlButton--Button"
        style={{ marginTop: '16px' }}
        onClick={handleCopyClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};
